<template>
  <!--    Register in Shaparak Modal-->
  <b-modal
    ref="my-modal"
    header-class="justify-content-center"
    centered
    hide-footer
    title="ثبت در سامانه شاپرک"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    v-model="visibility"
  >
    <div class="d-block direction-rtl">
      <b-row>
        <b-col cols="12" class="error-detail-text"
          >{{ $translate("centralBankDirectiveForSecurity") }}
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="midnight-blue-text font-size-small pb-1 font-weight-bold"
          >{{ $translate("codeSentTo") }}
        </b-col>
        <b-col cols="12" class="midnight-blue-text pb-1 font-size-xs"
          >{{ $translate("enterTheSentCodeToYourMobilePhone") }}
        </b-col>
      </b-row>
      <b-row class="direction-ltr m-0 pb-2">
        <b-form-input
          id="otp-code"
          :placeholder="$translate('enterTheSentCode')"
          class="form-control mx-1"
          required
          v-model="cardEnrollmentOTPCode"
          v-mask="'######'"
          :state="otpCodeValidation"
        ></b-form-input>
        <transition
          name="animate__fadeIn"
          enter-active-class="animate__animated animate__fadeIn"
          leave-active-class="animate__animated animate__fadeOut"
          appear
        >
          <b-form-invalid-feedback
            class="font-size-xs direction-rtl"
            id="otp-code-feedback"
            v-if="cardEnrollmentOTPCode.length > 6"
          >
            {{ $translate("maximum6CharactersAllowed") }}
          </b-form-invalid-feedback>
        </transition>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="midnight-blue-text font-size-small pb-1 font-weight-bold"
          >{{ $translate("cardExpireTime") }}:
        </b-col>
        <b-col
          cols="12"
          class="midnight-blue-text font-size-xs pb-1 font-weight-bold"
        >
          {{ $translate("enterTheMonthAndYearOfCardExpiration") }}
        </b-col>
      </b-row>
      <b-row class="midnight-blue-text m-0 pb-3">
        <b-col cols="6" class="pr-0 pl-0point5">
          <b-form-input
            id="expire-date-month"
            :placeholder="$translate('month')"
            pattern="\d*"
            inputmode="numeric"
            v-mask="'##'"
            mask="false"
            required
            v-model="cardEnrollmentExpireDateMonth"
            :state="monthDateValidation"
          ></b-form-input>
        </b-col>
        <b-col cols="6" class="pl-0 pr-0point5">
          <b-form-input
            id="expire-date-year"
            :placeholder="$translate('year')"
            pattern="\d*"
            inputmode="numeric"
            v-mask="'##'"
            mask="false"
            required
            v-model="cardEnrollmentExpireDateYear"
            :state="yearDateValidation"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <button class="modal-button" @click="cardEnrollmentRequest()">
            <span>{{ $translate("submit") }}</span>
          </button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
  <!--    Register in Shaparak Modal-->
</template>

<script>
import alertHelper from "@/helper/AlertHelper";
import { mapGetters } from "vuex";

export default {
  name: "ShaparakRegisterModal",
  props: {
    visibility: Boolean,
  },
  data() {
    return {
      cardEnrollmentRequestPending: false,
      cardEnrollmentOTPCode: "",
      cardEnrollmentExpireDateYear: "",
      cardEnrollmentExpireDateMonth: "",
    };
  },
  computed: {
    ...mapGetters(["getTransactionId"]),
    monthDateValidation() {
      return (
        this.cardEnrollmentExpireDateMonth <= 12 &&
        this.cardEnrollmentExpireDateMonth.length === 2
      );
    },
    yearDateValidation() {
      return this.cardEnrollmentExpireDateYear.length === 2;
    },
    otpCodeValidation() {
      return (
        this.cardEnrollmentOTPCode.length < 7 && this.cardEnrollmentOTPCode > 2
      );
    },
  },
  watch: {
    // Auto Focus (Auto Tab) When The Fields Are Full
    cardEnrollmentExpireDateMonth(value) {
      if (value.length === 2 && this.monthDateValidation) {
        document.getElementById("expire-date-year").focus();
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    inputValidations() {
      let expDateConcat = this.cardEnrollmentExpireDateYear.concat(
        this.cardEnrollmentExpireDateMonth
      );
      const otpCodeValidation =
        this.cardEnrollmentOTPCode === "" ||
        this.cardEnrollmentOTPCode.length !== 6;
      return (
        otpCodeValidation ||
        expDateConcat.length < 4 ||
        this.cardEnrollmentExpireDateMonth > 12
      );
    },
    //Submit Information
    cardEnrollmentRequest() {
      const transactionId = this.getTransactionId;
      let expDateConcat = this.cardEnrollmentExpireDateYear.concat(
        this.cardEnrollmentExpireDateMonth
      );
      if (this.inputValidations()) {
        alertHelper.errorAlert("", "لطفا تمامی فیلد هارا به درستی پر کنید");
      } else {
        alertHelper.loadingAlert();
        this.cardEnrollmentRequestPending = true;
        this.$http
          .post(`shetab/${transactionId}/card-enrollment`, {
            otp_code: this.cardEnrollmentOTPCode,
            exp_date: expDateConcat,
          })
          .then(
            (result) => {
              alertHelper.successAlert("", result.data.data.message, 3000);
              this.closeModal();
            },
            (error) => {
              alertHelper
                .apiErrorAlert("", error.body.message, 20000)
                .then(() => {
                  this.closeModal();
                });
            }
          );
      }
    },
  },
};
</script>

<style scoped>
.modal-button {
  width: 50%;
  padding: 5px;
  margin-top: 20px;
  color: #ffffff;
  border-radius: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: var(--dodger-blue);
  border: none;
}

.error-detail-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--midnight-blue);
  font-size: 0.8rem;
  text-align: center;
  padding-bottom: 15px;
}
</style>
